import { AbstractMessageHandler } from "@/services/rest/messages/message-handler";
import { XmlRequest } from "@/services/rest/xml-request";
import { getRequiredAttribute, getRequiredChild } from "@/utils/xml-helper-functions";
import { LocalizedError } from "@/services/rest/errors";

export class AVc21DepositMessageHandler extends AbstractMessageHandler<void> {
    protected readonly requestType: string = "A.VC.2.1";
    constructor (readonly voucherCode: string) {
        super();
    }

    buildRequest (request: XmlRequest) {
        const actionElement = request.addChild(request.body, "action", {
            type: this.requestType
        });
        const voucherElement = request.addChild(actionElement, "Voucher");
        request.addChildWithValue(voucherElement, "VoucherCode", this.voucherCode.toString());
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    parseMessageBody (body: Element, _head: Element): void {
        const action = getRequiredChild(body, "action");
        const serverCode = getRequiredAttribute(action, "servercode");

        if (serverCode !== "4300") {
            throw new LocalizedError(`errors.mtl.code${serverCode}`);
        }
    }
}
